// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import type { Office } from '../../../types/OfficesType';

type Props = {
  office: Office,
}

class OfficeDescription extends React.Component<Props> {
  render() {
    return (
      <div className="building-description">
        <div className="title">
          <Translate value="OFFICE.OFFICEDESCRIPTION" />
        </div>
        <div className="data-description">
          <div dangerouslySetInnerHTML={{ __html: this.props.office.projectDescription }} />
        </div>
      </div>
    );
  }
}

export default OfficeDescription;
